export const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder_key';
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

export async function redirectToCheckout(sessionData) {
  try {
    const response = await fetch(`${API_BASE}/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(sessionData)
    });
    
    const data = await response.json();
    
    if (response.ok && data.checkout_url) {
      window.location.href = data.checkout_url;
    } else {
      // Handle API errors properly
      throw new Error(data.error || `Server error: ${response.status}`);
    }
  } catch (error) {
    console.error('Payment error:', error);
    throw error;
  }
}

export async function getUserCredits() {
  try {
    const response = await fetch(`${API_BASE}/user-credits`, {
      credentials: 'include'
    });
    const data = await response.json();
    return data.credits_remaining || 0;
  } catch (error) {
    console.error('Failed to load user credits:', error);
    return 0;
  }
}